import { useCheckoutInitError } from './useCheckoutInitError';
import { useInitSuccess } from './useInitSuccess';
import { useShouldSubmit } from './useShouldSubmit';
import { useSubmitError } from './useSubmitError';
import { useSubmitSuccess } from './useSubmitSuccess';
export const useCheckoutCallbacks = _ref => {
  let {
    shouldOpenDoublePurchaseModal
  } = _ref;
  const {
    eventAggregator,
    handleInitSuccess,
    didInitSuccess
  } = useInitSuccess();
  const {
    getShouldSubmit
  } = useShouldSubmit({
    shouldOpenDoublePurchaseModal,
    eventAggregator
  });
  const {
    handleSubmitSuccess
  } = useSubmitSuccess({
    eventAggregator
  });
  const {
    handleInitError
  } = useCheckoutInitError();
  const {
    handleSubmitError
  } = useSubmitError({
    eventAggregator
  });
  return {
    eventAggregator,
    getShouldSubmit,
    handleSubmitSuccess,
    handleInitSuccess,
    handleInitError,
    handleSubmitError,
    didInitSuccess
  };
};
//# sourceMappingURL=useCheckoutCallbacks.js.map